import { Check } from '@mui/icons-material';
import { Box, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import { kebabCase } from 'lodash';

/**
 * A list of highlighted features for a billing preference type.
 */
const BillingOptionCard = ({ features, title }: { features: string[]; title: string }) => {
  return (
    <Card variant="outlined" sx={{ backgroundColor: 'grey.50', height: '100%' }}>
      <CardContent>
        <Typography variant="h2">
          {title}
        </Typography>
        <List dense>
          {features.map(feature => (
            <ListItem key={kebabCase(feature)} sx={{ padding: 0.5 }}>
              <ListItemIcon sx={{ minWidth: '24px' }}>
                <Check color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={feature}
                primaryTypographyProps={{
                  color: 'text.primary'
                }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

/**
 * Comparison of the different billing options available.
 */
export const BillingOptionsComparison = () => {
  return (
    <Box>
      <Typography variant="h2" gutterBottom>Billing Options</Typography>
      <Typography color="text.secondary" variant="body2" marginBottom={2}>
        Review the difference between Standard and Prepaid Billing before making your selections below.
      </Typography>
      <Grid container spacing={3}>
        <Grid xs={12} sm={6}>
          <BillingOptionCard
            title="Standard Billing"
            features={[
              'Billed monthly based on meter read',
              'Available for all services',
              'Deposit may be required',
              'No minimum balance required'
            ]}
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <BillingOptionCard
            title="Prepaid Billing"
            features={[
              'Pay-as-you-go and maintain a daily credit balance',
              'Available for electric service only',
              'Lower deposit than Standard Billing',
              'No late fees or disconnect fees'
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
